module.exports = __webpack_public_path__ + "img/15.e71c2bf3.png";